export const UPLOAD_DOCUMENT = 'UPLOAD_DOCUMENT';
export const DELETE_DOCUMENT = 'DELETE_DOCUMENT';
